import { supabase } from '../lib/supabase';

// ─────────────────────────────────────────────────────────────────────────────
// Controle de custo da geocodificação do Google (`geocode-search`).
// A Lemit já registra quem/quando/quanto em `lemit_consultas`; o geocode não
// registrava nada, então não dava para auditar o gasto. Isto fecha essa lacuna.
// ─────────────────────────────────────────────────────────────────────────────

/** Google Geocoding API: ~US$ 5,00 por 1.000 requisições (tabela padrão). */
export const CUSTO_GEOCODE_USD = 0.005;

export interface GeocodeLogRow {
    id: string;
    user_id: string | null;
    user_nome: string | null;
    origem: string;
    enderecos: number;
    sucesso: number;
    custo_estimado_usd: number;
    created_at: string;
}

/** Registra um lote de geocodificação (best-effort: não quebra o fluxo se falhar). */
export async function registrarGeocode(params: {
    userId?: string | null;
    userNome?: string | null;
    origem?: string;
    enderecos: number;
    sucesso: number;
}): Promise<void> {
    try {
        await supabase.from('geocode_api_log').insert({
            user_id: params.userId ?? null,
            user_nome: params.userNome ?? null,
            origem: params.origem || 'lista_fria',
            enderecos: params.enderecos,
            sucesso: params.sucesso,
            custo_estimado_usd: Number((params.enderecos * CUSTO_GEOCODE_USD).toFixed(4)),
        });
    } catch (e) {
        console.error('geocode_api_log:', e);
    }
}

export interface GeocodeStats {
    chamadas: number;      // nº de lotes
    enderecos: number;     // endereços geocodificados (= requisições pagas)
    custoUsd: number;
}

/** Log detalhado (quem, quando, quantos, quanto). */
export async function getGeocodeLog(limite = 200): Promise<GeocodeLogRow[]> {
    const { data } = await supabase
        .from('geocode_api_log')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(limite);
    return (data as GeocodeLogRow[]) || [];
}

/** Totais a partir de uma data (ex.: início do mês) — alimenta os KPIs. */
export async function getGeocodeStats(fromISO?: string): Promise<GeocodeStats> {
    let q = supabase.from('geocode_api_log').select('enderecos, custo_estimado_usd');
    if (fromISO) q = q.gte('created_at', fromISO);
    const { data } = await q;
    const rows = data || [];
    return {
        chamadas: rows.length,
        enderecos: rows.reduce((s: number, r: any) => s + (r.enderecos || 0), 0),
        custoUsd: rows.reduce((s: number, r: any) => s + Number(r.custo_estimado_usd || 0), 0),
    };
}
